import * as Api from '../../api';
import Utils from '../../untils';
import Vue from 'vue'
const state = {
};

const getters = {
};

const mutations = {
};
const actions = {

  createUConnectSession({ state, rootState}, {params, callback}) {
    console.log('MAKE RESERVATION PARAMS: ', params);
    let obj = {
      action: `/oa/u-connect/create-checkout-session`,
      ...params
    }

    Api.requestbody(obj, { show: false }).then(resp => {
      console.log('MAKE RESERVATION RESP: ', resp);
      if (callback) {
        callback(resp, "createUConnectSessionCallback");
      }
    });
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/stripe.js